module.exports = __webpack_public_path__ + "static/media/dot-net-core.2bcafa8d.svg";